import React from "react";
// import { useDrag } from 'react-dnd'

export const PetCardQuestion = ({
  id,
  text,
  code,
  type,
  answers,
  mode,
  addItem,
}) => {
  // const [{ isDragging }, dragRef] = useDrag({

  return (
    <div key={id}>
      <div
        style={{
          cursor: "pointer",
          minWidth: 20,
          paddingRight: 2,
          paddingLeft: 2,
          minHeight: 25,
          backgroundColor: "gray",
          margin: 2,
          borderRadius: 3,
          color: "#FFF",
          fontSize: 14,
        }}
        onClick={() => {
          console.log(id, text, code, type, mode);
          addItem({
            id,
            text,
            code,
            type,
            mode,
          });
        }}
      >
        {code + "  -  " + text}
      </div>
      <div>
        {answers?.map((ans) => (
          <div
            key={ans.id}
            style={{
              cursor: "pointer",
              minWidth: 20,
              paddingRight: 12,
              paddingLeft: 12,
              minHeight: 25,
              backgroundColor: "lightgray",
              margin: 2,
              borderRadius: 3,
              color: "#000",
              fontSize: 13,
            }}
            onClick={() => {
              addItem({
                id: ans.value,
                text: ans.text,
                type: "user",
              });
            }}
          >
            {"(" + ans.value + ") " + ans.text}
          </div>
        ))}
      </div>
    </div>
  );
};
